"use client";

import React from "react";

import { cn } from "utils";
import { CountdownCard } from "./CountdownCard";
import Translations from "@translate/components/CountDown/Countdown";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface CountdownProps {
  countdown: any;
  labelMap?: any;
  className?: string;
  containerClassName?: string;
  textClassName?: string;
  countDownClassName?: string;
}

// 时间单位组件 - 包含十位和个位，使用两个 ref 分别记录
export const Countdown: React.FC<CountdownProps> = (props) => {
  const defaultLabelMap = {
    days: I18n.t("Days"),
    hours: I18n.t("Hours"),
    minutes: I18n.t("Min"),
    seconds: I18n.t("Sec"),
  } as const;
  const { countdown, labelMap = defaultLabelMap, ...rest } = props;
  const timeKeys = Object.keys(countdown);
  return (
    <>
      {timeKeys?.map((key: string, index) => (
        <div key={key} className="flex items-center">
          <CountdownCard
            value={countdown[key]}
            label={(labelMap as any)[key]}
            className={cn(
              "bg-background_white_overlay10 md:w-[48px] w-[48px] md:h-[52px] h-[52px] border border-border_white_transparent10",
              rest.className,
            )}
            countDownClassName={cn(
              "md:w-[48px] w-[48px] md:h-[32px]",
              rest.countDownClassName,
            )}
            containerClassName={cn(
              "md:w-[27px] w-[27px]",
              rest.containerClassName,
            )}
            textClassName={cn(
              "text-content_primary md:headline_regular_s headline_regular_s md:w-[27px] w-[27px]",
              rest.textClassName,
            )}
          />
          <span
            className={cn("title_l text-content_primary w-4 text-center", {
              hidden: index === timeKeys.length - 1,
            })}
          >
            :
          </span>
        </div>
      ))}
    </>
  );
};
